export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f216698e68d5efe88725d223cfaa6a63451e03608&name=fetchTypeahead!'